export default "__VITE_ASSET__zk$de09N__"